import styled, { css } from 'styled-components';
import {
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_RELATIVE_MD,
  SYS_COLOR_SURFACE_SCRIM_DEFAULT_DARK,
  SYS_SPACE_FIXED_150,
  SYS_SPACE_RELATIVE_XS,
} from '@oneaudi/unified-web-common';
import { dynamicStylingHelper } from '@oneaudi/vtp-shared';

export const LinkButtonContainer = styled.div`
  padding: 0 0;
`;

export const AlphaOnlyWrapper = styled.div`
  padding: ${SYS_SPACE_RELATIVE_MD};
  & p {
    margin: 0;
  }
`;

export const ConsumptionEmissionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${dynamicStylingHelper(SYS_SPACE_FIXED_100, '')};
  align-self: stretch;
`;
export const ButtonContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  row-gap: ${SYS_SPACE_RELATIVE_XS};
  ${dynamicStylingHelper(`margin-bottom: ${SYS_SPACE_FIXED_200}`)};
`;
export const ButtonContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${SYS_SPACE_FIXED_100};
  ${dynamicStylingHelper(`margin-bottom: ${SYS_SPACE_FIXED_200}`)};

  & > *:first-child {
    flex: 1;
  }
`;

export const FavoritesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-shrink: 0;
`;

export const FavoritesOverlay = styled.div`
  position: absolute;
  z-index: 0;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${SYS_COLOR_SURFACE_SCRIM_DEFAULT_DARK};

  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;

const GridButtonStyles = css`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  gap: ${SYS_SPACE_FIXED_150};

  button {
    width: 100%;
  }
`;

export const GridButtonContainer = styled.div`
  ${GridButtonStyles}
`;
